export default "__VITE_ASSET__nHDl1iY9__"